export const SourceConstants = {
  trafficTypes: [
    {
      label: 'Incent',
      value: 20,
    },
    {
      label: 'Network',
      value: 30,
    },
    {
      label: 'In-app',
      value: 40,
    },
    {
      label: 'Direct',
      value: 50,
    },
  ],
  payoutType: [
    {
      label: 'CPI',
      value: 'CPI',
    },
    {
      label: 'CPA',
      value: 'CPA',
    },
    {
      label: 'CPL',
      value: 'CPL',
    },
  ],
  payoutTypes: [
    {
      label: 'All',
      value: '',
    },
    {
      label: 'CPI',
      value: 'CPI',
    },
    {
      label: 'CPA',
      value: 'CPA',
    },
    {
      label: 'CPL',
      value: 'CPL',
    },
    {
      label: 'SmartLink',
      value: 'SmartLink',
    },
  ],
  sourceStatus: [
    {
      label: 'enable',
      value: 'enable',
    },
    {
      label: 'disable',
      value: 'disable',
    },
    {
      label: 'pending',
      value: 'pending',
    },
    {
      label: 'reject',
      value: 'reject',
    },
    {
      label: 'prepare',
      value: 'prepare',
    },
  ],
  sourceUpdateStaatus: [
    {
      label: 'ENABLE',
      value: 'ENABLE',
    },
    {
      label: 'Disable',
      value: 'DISABLE',
    },
    {
      label: 'Pending',
      value: 'PENDING',
    },
    {
      label: 'Reject',
      value: 'REJECT',
    },
    {
      label: 'Prepare(稍后开启)',
      value: 'PREPARE',
    },
  ],
};

export const AffiliateConstants = {
  levelOption: [
    {
      label: 'Direct',
      value: 50,
    },
    {
      label: 'In-app',
      value: 40,
    },
    {
      label: 'Network',
      value: 30,
    },
    {
      label: 'MediaBuy',
      value: 20,
    },
    {
      label: 'Incent',
      value: 10,
    },
  ],
  isDynamicPbOptions: [
    {
      label: 'NO',
      value: 0,
    },
    {
      label: 'YES',
      value: 1,
    },
  ],
  trafficType: [
    {
      label: 'CPI',
      value: 'CPI',
    },
    {
      label: 'CPA',
      value: 'CPA',
    },
    {
      label: 'CPL',
      value: 'CPL',
    },
  ],
  offerMonitor: [
    {
      label: 'DISABLE',
      value: 'DISABLE',
    },
    {
      label: 'ENABLE',
      value: 'ENABLE',
    },
  ],

  clickLimiteOptions: [
    {
      label: 'OPEN',
      value: 'OPEN',
    },
    {
      label: 'CLOSE',
      value: 'CLOSE',
    },
  ],

  statusOption: [
    {
      label: 'ACTIVE',
      value: 'active',
    },
    {
      label: 'PENDING',
      value: 'pending',
    },
    {
      label: 'PAUSED',
      value: 'paused',
    },
  ],
};

export const getTrafficType = (value) => {
  return SourceConstants.trafficTypes.find((item) => item.value === value)?.label;
};

export const RoleName = {
  PM: 'ProjectManager',
  BD: 'BusinessManager',
  AM: 'AffiliateManager',
};

export const IntegrationType = ['Hypertap(Api)', 'Adjust', 'AF', 'Other'];
